import { ChartDataset } from 'chart.js';
import { formatUsd } from '@dapp/multi-lib/lib/formatters';

interface ChartLegendProps {
  labels: string[];
  dataset: ChartDataset<'pie'>;
}

export const ChartLegend = (props: ChartLegendProps) => {
  const { labels, dataset } = props;

  const sum = dataset.data.reduce((a, b) => a + b, 0);

  const calcPercentage = (value: number) => {
    if (sum === 0) return '0.00';
    return ((value / sum) * 100).toFixed(2);
  };

  return (
    <div className='flex flex-col gap-2'>
      {labels.map((label, i) => (
        <LegendItem
          key={i}
          color={(dataset.backgroundColor as string[])?.[i]}
          label={
            <span className='text-sm text-white'>
              {label}: <b>${formatUsd(dataset.data[i])}</b> (
              {calcPercentage(Number(dataset.data[i]))}%)
            </span>
          }
        />
      ))}
    </div>
  );
};

interface LegendItemProps {
  color: string;
  label: React.ReactNode;
}

const LegendItem = ({ color, label }: LegendItemProps) => {
  return (
    <div className='flex items-center gap-2'>
      <div
        className='h-3 w-3 rounded-full'
        style={{ backgroundColor: color }}
      />
      {label}
    </div>
  );
};
